var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shibie"},[_c('div',{staticClass:"title"},[_vm._v("人脸识别")]),_c('canvas',{attrs:{"id":"canvasCemara","width":"500","height":"500"}}),_c('video',{staticStyle:{"width":"500px","height":"500px"},attrs:{"autoplay":"","id":"video2"}}),_c('button',{attrs:{"id":"btn"}},[_vm._v("拍摄")])])
}]

export { render, staticRenderFns }